import React from 'react';

import RouteSynchronizer from '../common/components/RouteSynchronizer';

const importers = {
    login: () => import('./Authentication/views/Login'),
    register: () => import('./Authentication/views/Register'),
    passwordReset: () => import('./Authentication/views/PasswordReset'),
    passwordResetPin: () => import('./Authentication/views/PasswordReset/PasswordResetPin'),
    forgotResetPassword: () => import('./Authentication/views/PasswordReset/ForgotResetPassword'),
    newChangePassword: () => import('./NewChangePassword/views'),
    payment: () => import('./Payment/views'),
    changePassword: () => import('./ChangePassword/views'),
    main: () => import('./HomeScreen/views'),
    home: () => import('./Authentication/views/Login'),
    overview: () => import('./Overview/views'),
    portfolio: () => import('./Portfolio/views'),
    equity: () => import('./Equity/views'),
    announcements: () => import('./Announcements/views'),
    comparative: () => import('./Comparative/views'),
    technicalScan: () => import('./TechnicalScan/views'),
    DalalStreet: () => import('./DalalStreet/views'),

    // for referral Links
    Dashboard: () => import('./ReferralDashboard/views/ReferralComponent/index'),
    TermsAndConditions: () => import('./ReferralDashboard/views/TermsAndConditions'),
    // fourHundredFour: () => import('./FourHundredFour/views'),
};

const loadWithNewHeader = ['Dashboard', 'TermsAndConditions'];
const views = Object.keys(importers).reduce(
    (acc, key) => {
        const importer = importers[key];
        acc[key] = props => (
            <RouteSynchronizer
                {...props}
                load={importer}
            />
        );
        return acc;
    },
    {},
);
export { loadWithNewHeader };

export default views;




// WEBPACK FOOTER //
// ./src/topic/index.js